/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Component, Input } from "@angular/core";
import { AbstractModalComponentWithInputText } from "../abstract-modal.component.with-input-text";

@Component({
   standalone: false,
   selector: "cancel-confirm-dialog-with-input-text",
   templateUrl: "./cancel-confirm-dialog-with-input-text.component.html",
   styles: [
      `
         /deep/ .modal.show .modal-dialog {
            width: 451.89px;
         }
      `
   ]
})
export class CancelConfirmDialogWithInputTextComponent extends AbstractModalComponentWithInputText {
   @Input() public title;
   @Input() public message;
   @Input() public buttonLabelConfirm?;
   @Input() public buttonLabelCancel?;
}
